import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';
import { LookupOnlineSelectFinancasResponse } from '../../responses/financas/lookup-online-select.response';
import { GetRateioCentroCustoResponse } from '../../responses/financas/get-rateio-centro-custo.response';

@Injectable({
  providedIn: 'root',
})
export class FinancasLookupService extends CommonService {
  private readonly apiUrl = `${environment.urlApiFinancas}Lookup/`;

  constructor(private httpClient: HttpClient) {
    super();
  }

  private getLookup(path: string, textoBusca?: string): Observable<LookupOnlineSelectFinancasResponse> {
    let params = new HttpParams();

    if (textoBusca) {
      params = params.set('textoBusca', textoBusca);
    }

    return this.httpClient
      .get<LookupOnlineSelectFinancasResponse>(this.apiUrl + path, { params, ...this.addHeaderToken() })
      .pipe(catchError(this.handleError));
  }

  public listCategoriaFinanceiraSelect(textoBusca?: string): Observable<LookupOnlineSelectFinancasResponse> {
    return this.getLookup('listCategoriaFinanceiraSelect', textoBusca);
  }

  public listTagContasReceberSelect(textoBusca?: string): Observable<LookupOnlineSelectFinancasResponse> {
    return this.getLookup('listTagContasReceberSelect', textoBusca);
  }

  public listFormaRecebimentoSelect(textoBusca?: string): Observable<LookupOnlineSelectFinancasResponse> {
    return this.getLookup('listFormaRecebimentoSelect', textoBusca);
  }

  public listCentroCustoSelect(textoBusca?: string): Observable<LookupOnlineSelectFinancasResponse> {
    return this.getLookup('listCentroCustoSelect', textoBusca);
  }

  public listRateioCentroCustoSelect(textoBusca?: string): Observable<LookupOnlineSelectFinancasResponse> {
    return this.getLookup('listRateioCentroCustoSelect', textoBusca);
  }

  public listRateioCentroCustoConfig(textoBusca?: string): Observable<GetRateioCentroCustoResponse> {
    let params = new HttpParams();

    if (textoBusca) {
      params = params.set('textoBusca', textoBusca);
    }

    return this.httpClient
      .get<GetRateioCentroCustoResponse>(this.apiUrl + 'listRateioCentroCustoConfig', {
        params,
        ...this.addHeaderToken(),
      })
      .pipe(catchError(this.handleError));
  }

  public listContaFinanceiraSelect(textoBusca?: string): Observable<LookupOnlineSelectFinancasResponse> {
    return this.getLookup('listContaFinanceiraSelect', textoBusca);
  }

  public listStatusContasReceberSelect(textoBusca?: string): Observable<LookupOnlineSelectFinancasResponse> {
    return this.getLookup('listStatusContasReceberSelect', textoBusca);
  }

  public listFrequenciaRecorrenciaSelect(textoBusca?: string): Observable<LookupOnlineSelectFinancasResponse> {
    return this.getLookup('listFrequenciaRecorrenciaSelect', textoBusca);
  }

  public listTipoParcelamentoSelect(textoBusca?: string): Observable<LookupOnlineSelectFinancasResponse> {
    return this.getLookup('listTipoParcelamentoSelect', textoBusca);
  }

}
